var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#1162FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1665 15.4167C16.676 15.4167 15.4165 16.6762 15.4165 18.1667C15.4165 19.6572 16.676 20.9167 18.1665 20.9167C19.657 20.9167 20.9165 19.6572 20.9165 18.1667C20.9165 16.6762 19.657 15.4167 18.1665 15.4167Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 11.75H23.1295L20.6481 9.26858C20.5631 9.1833 20.4621 9.11566 20.3509 9.06956C20.2396 9.02347 20.1204 8.99983 20 9H16.3333C16.2129 8.99983 16.0937 9.02347 15.9825 9.06956C15.8712 9.11566 15.7702 9.1833 15.6853 9.26858L13.2038 11.75H10.8333C9.82225 11.75 9 12.5723 9 13.5833V23.6667C9 24.6778 9.82225 25.5 10.8333 25.5H25.5C26.5111 25.5 27.3333 24.6778 27.3333 23.6667V13.5833C27.3333 12.5723 26.5111 11.75 25.5 11.75ZM18.1667 22.75C15.6825 22.75 13.5833 20.6508 13.5833 18.1667C13.5833 15.6825 15.6825 13.5833 18.1667 13.5833C20.6508 13.5833 22.75 15.6825 22.75 18.1667C22.75 20.6508 20.6508 22.75 18.1667 22.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/CameraIcon.82601134.svg";
export { ForwardRef as ReactComponent };